import Tooltip from './Tooltip';

// export types
export type { TooltipProps } from './Tooltip';

// export components
export { Tooltip };
export default Tooltip;
